import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';
import { IconDownload } from '$partials/icons';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleDownloads = ({
    files,
    images
}) => {
    if (!files) { return null; }

    return (
        <div className='my-44 md:my-70'>
            <ul>
                {files.items?.map((file, i) => {
                    if (!file) { return null; }

                    const type = file.contentType ? file.contentType.match(/^(?:application|image)\/(\w+)/i)?.[1] : null;
                    const size = file.size ? Math.round(file.size * 0.00001) / 10 : null;

                    return (
                        <li
                            className='flex flex-wrap items-center pb-20 sm:pb-30'
                            key={i}>
                            <div className='w-full border-t border-grey mx-10 sm:mx-15 h-1 pb-20 sm:pb-30' />
                            <div className='flex flex-wrap items-center w-3/4 sm:w-5/6 md:w-11/12'>
                                <div className='w-full sm:w-1/5 md:w-[36.363%] px-10 sm:px-15 type-style-7 text-dark-grey uppercase'>
                                    {`${type}${(type && size) ? ' — ' : ''}${size ? `${size} MB` : ''}`}
                                </div>
                                <div className='w-full sm:w-4/5 md:w-[63.636%] px-10 sm:px-15 type-style-3'>
                                    {file.title}
                                </div>
                            </div>
                            <div className='w-1/4 sm:w-1/6 md:w-1/12 px-10 sm:px-15'>
                                <a
                                    className='block float-right'
                                    href={file.url}
                                    rel='noreferrer'
                                    target='_blank'>
                                    <IconDownload />
                                </a>
                            </div>
                        </li>
                    );
                })}
            </ul>
            {!!images?.items &&
                <ul className='flex flex-wrap'>
                    {images.items.map((image, i) => {
                        return (
                            <li
                                className='w-full sm:w-2/6 px-10 sm:px-15 pb-20 sm:pb-0'
                                key={i}>
                                <Image
                                    loadWidth={370}
                                    {...image} />
                            </li>
                        );
                    })}
                </ul>
            }
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleDownloads.propTypes = {
    files: PropTypes.shape({
        items: PropTypes.array.isRequired
    }).isRequired,
    images: PropTypes.shape({
        items: PropTypes.array.isRequired
    })
};

export default ModuleDownloads;
